export enum CONTACT_METHODS {
	CHAT = 'chat',
	PHONE = 'phone',
	EMAIL = 'email',
	CONTACT_FORM = 'contactForm',
	EXTERNAL_CHAT = 'externalChat',
	CONTACT_CONDITIONS = 'contactConditions',
	WHATSAPP = 'whatsapp',
}
